import * as ReactRedux from 'react-redux'
import * as React from 'react'

import * as Http from '../http-module'
import * as ServerConfiguration from '../server-configuration'
import { redirect } from '../http'

export function useLocaleRedirect() {
  const configuration = ServerConfiguration.useContext()
  const dispatch = ReactRedux.useDispatch()
  const basename = Http.useBasename()
  const url = Http.useUrl()

  // TODO: Migrate to `http-module`
  const redirected = React.useMemo(() => {
    // For CasinoskyJP, we always want to redirect to ja-JP local
    // unless the local is blocked
    const nextBasename =
      configuration?.brand !== 'casinoskyjp' ||
      configuration?.country?.access !== 'ALLOWED'
        ? `/${configuration.locale.slug}`
        : '/ja-JP'
    const isLocaleIncorrect = basename !== nextBasename

    if (isLocaleIncorrect) {
      dispatch(redirect(`${nextBasename}${url}`))

      if (process.browser) {
        window.location.replace(`${nextBasename}${url}`)
      }

      return true
    }

    return false
  }, [basename, configuration, dispatch, url])

  return redirected
}
